const LOCAL = 'local'
const STG1 = 'stg1'
const PPD1 = 'ppd1'
const LIVE = 'live'

export default (hostname) => {
  // const { location: { hostname = '' } = {} } = window
  let env = LOCAL
  if (hostname.includes(STG1)) env = STG1
  else if (hostname.includes(PPD1)) env = PPD1
  else if (hostname.includes('yoti.com')) env = LIVE
  return env
}
